<template>
  <v-ons-row class="header d-flex p-fixed justify-center items-center">
    <slot name="header" />
  </v-ons-row>
</template>

<style scoped>
.header {
  top: 0;
  left: 0;
  right: 0;
  height: 10vh;
  height: 10dvh;
  background-color: #fff;
  font-size: 1.8rem;
  font-weight: bold;
  z-index: 100;
}
</style>
